// Updated Header component with Shop Manual button
import React, { useRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import newChatPnc from "../../assets/newChatPnc.svg";
import historyClosePnc from "../../assets/toggle-button.svg";
import about from "../../assets/aboutPNC.png";
import userImage from "../../assets/profilePnc.png";
import headerHistory from "../../assets/queryHistoryPnc.svg";
import logoutPnc from "../../assets/logoutSM.svg";
import fusoLogo from "../../assets/fuso-logo.svg";
import toggleBtn from "../../assets/historyToggleMobile.svg";
import "./Header.css";
import goto from "../../assets/navigate.svg";
import shop from "../../assets/shopmanuallogin.svg";
import { useLocation, useNavigate } from "react-router-dom";
import useIsAdmin from "../../admin/hooks/useIsAdmin";

const Header = ({
  isSidebarOpen,
  toggleSidebar,
  resetToWelcomePage,
  toggleAboutModal,
  showQueriesInChat,
  isQueriesDropdownOpen,
  setIsQueriesDropdownOpen,
  handleSelectPastQuery,
  isLogoutDropdownOpen,
  setIsLogoutDropdownOpen,
  handleLogout,
  messages,
  selectedLanguage,
  showLanguageMenu,
  setShowLanguageMenu,
  languageOptions,
  handleLanguageChange,
  currentPage,
  onNavigate,
}) => {
  const { t, i18n } = useTranslation();
  const { isAdmin } = useIsAdmin();
  const queriesDropdownRef = useRef(null);
  const logoutDropdownRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const languageMenuRef = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();

  const handleLanguageSelect = (languageCode) => {
    handleLanguageChange(languageCode);
    setShowLanguageMenu(false);
    i18n.changeLanguage(languageCode.split("-")[0]);
  };

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // FIXED: Proper secure navigation with security flags
  const handleNavigation = (pageId) => {
    
    // Set navigation security flags BEFORE navigation
    sessionStorage.setItem('navigation_in_progress', 'true');
    sessionStorage.setItem('navigation_timestamp', Date.now().toString());
    sessionStorage.setItem('legitimate_navigation', 'true');
    sessionStorage.setItem('app_initiated_navigation', 'true');
    
    // Set the target route
    let targetRoute;
    if (pageId === "pnc") {
      targetRoute = '/pnc';
    } else if (pageId === "shop-manual") {
      targetRoute = '/shop-manual';
    } else if (pageId === "admin") {
      targetRoute = '/admin';
    }
    
    if (targetRoute) {
      sessionStorage.setItem('navigation_target', targetRoute);
      
      // Navigate after a short delay to ensure flags are set
      setTimeout(() => {
        navigate(targetRoute);
        
        // Clean up flags after navigation
        setTimeout(() => {
          sessionStorage.removeItem('navigation_in_progress');
          sessionStorage.removeItem('app_initiated_navigation');
        }, 500);
      }, 50);
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        queriesDropdownRef.current &&
        !queriesDropdownRef.current.contains(event.target)
      ) {
        setIsQueriesDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setIsQueriesDropdownOpen]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        logoutDropdownRef.current &&
        !logoutDropdownRef.current.contains(event.target)
      ) {
        setIsLogoutDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setIsLogoutDropdownOpen]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        isMobileMenuOpen &&
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target)
      ) {
        setIsMobileMenuOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMobileMenuOpen]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        languageMenuRef.current &&
        !languageMenuRef.current.contains(event.target)
      ) {
        setShowLanguageMenu(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setShowLanguageMenu]);

  const toggleProfileDropdown = () => {
    setIsLogoutDropdownOpen(!isLogoutDropdownOpen);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleLanguageMenu = () => {
    setShowLanguageMenu(!showLanguageMenu);
  };

  const handleLanguageSelection = (langCode) => {
    if (handleLanguageChange) {
      handleLanguageChange(langCode);
      setShowLanguageMenu(false);
      const languageKey = langCode.split("-")[0];
      i18n.changeLanguage(languageKey);
      localStorage.setItem("selectedLanguage", languageKey);
    } else {
      console.error("handleLanguageChange function not passed to Header");
    }
  };

  const extractQuestionPart = (fullText) => {
    if (!fullText) return "";
    const normalizedText = fullText.replace(/\\n/g, "\n");

    const parts = normalizedText.split("\n");
    for (let i = parts.length - 1; i >= 0; i--) {
      if (parts[i].trim()) {
        return parts[i].trim();
      }
    }
    return fullText;
  };

  return (
    <header className="flex items-center justify-between headerBorder">
      <div className="flex items-center iconHeader">
        <div className="sm:hidden mr-4">
          <button
            className="flex items-center p-2 border-none"
            onClick={toggleSidebar}
          >
            <img src={toggleBtn} alt="Sidebar Open" />
          </button>
        </div>

        {!isSidebarOpen && (
          <div className="hidden sm:flex mr-4 cursor-pointer historyToggleClose">
            <div className="newChatOutter">
              <button className="newChatClose" onClick={resetToWelcomePage}>
                <img src={newChatPnc} alt={t("newChat")} />
              </button>
            </div>

            <div onClick={toggleSidebar}>
              <img
                src={historyClosePnc}
                alt="Toggle sidebar"
                className={`h-8 transform rotate-180 toggle-header ${
                  isSidebarOpen ? "toggle-closed" : "toggle-open"
                }`}
              />
            </div>
          </div>
        )}
      </div>

      <div className="sm:hidden absolute left-1/2 transform -translate-x-1/2 flex items-center justify-center">
        <img src={fusoLogo} alt="FUSO" className="h-[24px]" />
      </div>

      <div className="flex items-center p-[10px] gap-3">
        {/* Shop Manual Button - Desktop/Tablet */}
        {/* <div className="hidden sm:flex">
          <button
            className="flex items-center px-3 py-2 rounded-lg border border-gray-200 hover:bg-red-50 transition-colors duration-150 cursor-pointer bg-[#FFF5F5] whitespace-nowrap shop-manual-btn"
            onClick={() => handleNavigation("shop-manual")}
          >
            <img src={shop} alt={t("navigate")} className="h-5 w-5 mr-2 flex-shrink-0" />
            <span className="text-sm mr-2 xl:inline routingFont">{t("Shop Manual")}</span>
            <img src={goto} alt={t("navigate")} className="h-4 w-4 flex-shrink-0" />
          </button>
        </div> */}

        {showQueriesInChat && (
          <div
            className="historyHeaderPnc relative"
            ref={queriesDropdownRef}
            style={{
              backgroundColor: isQueriesDropdownOpen ? "#FFE0E0" : "",
            }}
          >
            <div
              className="flex queryparthistory cursor-pointer rounded-full border-gray-200"
              onClick={() => setIsQueriesDropdownOpen(!isQueriesDropdownOpen)}
            >
              <img src={headerHistory} alt="History" className="queryImgPnc" />
              <span className="hidden sm:inline queriesResPnc">{t("queriesInThisChat")}</span>
            </div>

            {isQueriesDropdownOpen && (
              <div className="hidden sm:block absolute top-full right-0 mt-2 bg-white rounded-lg shadow-lg z-50 w-[348px] max-h-[600px] overflow-y-auto border border-gray-200 historyQueryDropDown">
                <div className="p-1">
                  {messages
                    .filter(
                      (msg) =>
                        msg.sender === "user" &&
                        !msg.isUserFeedback &&
                        !msg.isYesOption
                    )
                    .map((query, index) => {
                      const fullQueryText = query.text || "";
                      const displayText = extractQuestionPart(fullQueryText);

                      return (
                        <div
                          key={`query-${query.messageId || index}`}
                          className="p-3 border-b border-gray-100 cursor-pointer hover:bg-red-50 transition-colors duration-150 query-item"
                          onClick={() => handleSelectPastQuery(fullQueryText)}
                          data-message-id={query.messageId}
                        >
                          <p className="text-gray-800">{displayText}</p>
                        </div>
                      );
                    })}
                </div>
              </div>
            )}

            {isQueriesDropdownOpen && (
              <div className="sm:hidden fixed inset-0 bg-black bg-opacity-50 z-50 flex flex-col justify-end">
                <div class="bg-white rounded-t-lg max-h-[80vh] overflow-hidden border border-gray-200 querySmallPnc flex flex-col">
                  <div className="bg-rose-50 flex justify-between items-center p-2 px-4 py-2 border-b border-gray-200 slideupModal querySmallPnc">
                    <h3 className="text-lg font-medium profileModalPnc">
                      {t("queriesInThisChat")}
                    </h3>
                    <button
                      className="text-2xl text-gray-500 crossFeedBtnPnc"
                      onClick={() => setIsQueriesDropdownOpen(false)}
                    >
                      <svg
                        className="svgFeedPnc"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </button>
                  </div>
                  <div class="overflow-y-auto p-1 flex-1">
                    {messages
                      .filter(
                        (msg) =>
                          msg.sender === "user" &&
                          !msg.isUserFeedback &&
                          !msg.isYesOption
                      )
                      .map((query, index) => {
                        const fullQueryText = query.text || "";
                        const displayText = extractQuestionPart(fullQueryText);

                        return (
                          <div
                            key={`query-${query.messageId || index}`}
                            className="p-3 border-b border-gray-100 cursor-pointer hover:bg-red-50 transition-colors duration-150 query-item"
                            onClick={() => {
                              handleSelectPastQuery(fullQueryText);
                              setIsQueriesDropdownOpen(false);
                            }}
                            data-message-id={query.messageId}
                          >
                            <p className="text-gray-800">{displayText}</p>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Admin Dashboard Button - Desktop (only for admin users) */}
        {isAdmin && (
          <div className="hidden sm:flex">
            <button
              className="flex items-center px-3 py-2 rounded-lg border border-gray-200 hover:bg-red-50 transition-colors duration-150 cursor-pointer bg-white whitespace-nowrap"
              onClick={() => handleNavigation("admin")}
              title="Admin Dashboard"
            >
              <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: 6, flexShrink: 0 }}>
                <rect x="3" y="3" width="11" height="11" rx="2" fill="#CC1A00" fillOpacity="0.15" stroke="#CC1A00" strokeWidth="1.5"/>
                <rect x="18" y="3" width="11" height="11" rx="2" fill="#CC1A00" fillOpacity="0.15" stroke="#CC1A00" strokeWidth="1.5"/>
                <rect x="3" y="18" width="11" height="11" rx="2" fill="#CC1A00" fillOpacity="0.15" stroke="#CC1A00" strokeWidth="1.5"/>
                <rect x="18" y="18" width="11" height="11" rx="2" fill="#CC1A00" fillOpacity="0.15" stroke="#CC1A00" strokeWidth="1.5"/>
              </svg>
              <span className="text-sm routingFont">Admin</span>
            </button>
          </div>
        )}

        <div className="hidden sm:flex relative" ref={languageMenuRef}>
          <button
            className="language-selector-btn flex items-center justify-center px-3 py-2 rounded-lg transition-colors border border-gray-200 hover:bg-gray-50 cursor-pointer langSelectNewPnc profileSectionSM"
            onClick={toggleLanguageMenu}
            style={{
              backgroundColor: showLanguageMenu ? "#FFE0E0" : "white",
            }}
          >
            <img
              src={
                languageOptions?.find((lang) => lang.code === selectedLanguage)
                  ?.flag
              }
              alt={
                languageOptions?.find((lang) => lang.code === selectedLanguage)
                  ?.alt || "Flag"
              }
              className="w-5 h-4 mr-2 object-cover rounded-sm"
            />
            <span className="text-sm font-medium mr-1">
              {languageOptions
                ?.find((lang) => lang.code === selectedLanguage)
                ?.code?.split("-")[0]
                ?.toUpperCase() || "EN"}
            </span>
            <svg
              className={`w-4 h-4 transition-transform ${
                showLanguageMenu ? "rotate-180" : ""
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </button>

          {showLanguageMenu && (
            <div className="absolute top-full mt-2 right-0 bg-white rounded-lg shadow-lg border border-gray-200 py-1 min-w-[140px] z-[100]">
              {languageOptions?.map((lang) => (
                <button
                  key={lang.code}
                  className={`w-full px-4 py-2 text-left hover:bg-gray-100 flex items-center border-none cursor-pointer ${
                    selectedLanguage === lang.code ? "bg-gray-50" : ""
                  }`}
                  onClick={() => handleLanguageSelection(lang.code)}
                >
                  <img
                    src={lang.flag}
                    alt={lang.alt}
                    className="w-5 h-4 mr-2 object-cover rounded-sm"
                  />
                  <span className="text-sm">{lang.name}</span>
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="hidden sm:flex aboutHeaderPnc">
          <div className="relative" ref={logoutDropdownRef}>
            <img
              src={userImage}
              alt="profile"
              className="h-[42px] cursor-pointer profilePnc"
              onClick={toggleProfileDropdown}
            />

            {isLogoutDropdownOpen && (
              <div className="absolute right-0 top-full mt-2 bg-white rounded-lg shadow-lg z-50 min-w-[8rem] border border-gray-200 profileSectionSM">
                {/* <div
                  className="cursor-pointer hover:bg-red-50 transition-colors duration-150 text-center logoutPnc navigateTO"
                  onClick={() => {
                    console.log('🔄 Navigation button clicked');
                    handleNavigation("shop-manual");
                    setIsLogoutDropdownOpen(false);
                  }}
                >
                  <div className="navigateSM">
                    <img className="logoHeight" src={shop} alt={t("navigate")} />
                    {t("Shop Manual")}
                  </div>
                  <div>
                    <img className="logoNavigateHeight" src={goto} alt={t("navigate")} />
                  </div>
                </div> */}

                <div
                  className="cursor-pointer hover:bg-red-50 transition-colors duration-150 text-center logoutPnc"
                  onClick={handleLogout}
                >
                  <img className="logoHeight" src={logoutPnc} alt={t("logout")} />
                  {t("logout")}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="sm:hidden relative">
          <button
            className="flex items-center p-2 border-none cursor-pointer"
            onClick={toggleMobileMenu}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
              ></path>
            </svg>
          </button>

          {isMobileMenuOpen && (
            <div
              ref={mobileMenuRef}
              className="absolute right-0 top-full mt-2 bg-white rounded-lg shadow-lg z-50 w-[200px] border border-gray-200"
            >
              <div className="border-b border-gray-200 p-3">
                <div className="text-sm font-medium text-gray-700 mb-2">
                  {t("language")}
                </div>
                <div className="space-y-2">
                  {languageOptions?.map((lang) => (
                    <button
                      key={lang.code}
                      className={`w-full px-3 py-2 text-left rounded hover:bg-red-50 transition-colors duration-150 flex items-center border-none cursor-pointer ${
                        selectedLanguage === lang.code ? "bg-red-50" : ""
                      }`}
                      onClick={() => {
                        handleLanguageSelection(lang.code);
                        setIsMobileMenuOpen(false);
                      }}
                    >
                      <img
                        src={lang.flag}
                        alt={lang.alt}
                        className="w-5 h-4 mr-2 object-cover rounded-sm"
                      />
                      <span className="text-sm">{lang.name}</span>
                    </button>
                  ))}
                </div>
              </div>

              {/* <div
                className="p-3 cursor-pointer hover:bg-red-50 transition-colors duration-150 flex items-center justify-between border-b border-gray-200"
                onClick={() => {
                  handleNavigation("shop-manual");
                  setIsMobileMenuOpen(false);
                }}
              >
                <div className="flex items-center">
                  <img src={shop} alt={t("navigate")} className="h-5 w-5 mr-2" />
                  <span>{t("Shop Manual")}</span>
                </div>
                <img src={goto} alt={t("navigate")} className="h-4 w-4" />
              </div> */}

              {/* Admin entry — mobile (only for admin users) */}
              {isAdmin && (
                <div
                  className="p-3 cursor-pointer hover:bg-red-50 transition-colors duration-150 flex items-center border-b border-gray-200"
                  onClick={() => {
                    handleNavigation("admin");
                    setIsMobileMenuOpen(false);
                  }}
                >
                  <svg width="18" height="18" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: 8, flexShrink: 0 }}>
                    <rect x="3" y="3" width="11" height="11" rx="2" fill="#CC1A00" fillOpacity="0.15" stroke="#CC1A00" strokeWidth="1.5"/>
                    <rect x="18" y="3" width="11" height="11" rx="2" fill="#CC1A00" fillOpacity="0.15" stroke="#CC1A00" strokeWidth="1.5"/>
                    <rect x="3" y="18" width="11" height="11" rx="2" fill="#CC1A00" fillOpacity="0.15" stroke="#CC1A00" strokeWidth="1.5"/>
                    <rect x="18" y="18" width="11" height="11" rx="2" fill="#CC1A00" fillOpacity="0.15" stroke="#CC1A00" strokeWidth="1.5"/>
                  </svg>
                  <span>Admin</span>
                </div>
              )}

              <div
                className="p-3 cursor-pointer hover:bg-red-50 transition-colors duration-150 flex items-center"
                onClick={handleLogout}
              >
                <img
                  src={logoutPnc}
                  alt={t("logout")}
                  className="h-5 w-5 mr-2"
                />
                <span>{t("logout")}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;